// @flow

export default {
  name: 'dashboard',
  path: '/dashboard',
  forwardTo: 'trading-desk.dashboard',
  loadComponent: () => import('./index'),
  i18n: ['trading-desk/dashboard']
};
